/**
 * Soleil AB
 * Author: Robin Persson
 * Date: Mon Dec 16 2019 15:13:13 GMT+0100 (GMT+01:00)
 * Build script version: 2.2.4
 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof browserify_require=="function"&&browserify_require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof browserify_require=="function"&&browserify_require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":6,"../../modules/es6.object.assign":38}],2:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],3:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":19}],4:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":31,"./_to-iobject":33,"./_to-length":34}],5:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],6:[function(require,module,exports){
var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],7:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":2}],8:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],9:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":13}],10:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":14,"./_is-object":19}],11:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],12:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":6,"./_ctx":7,"./_global":14,"./_hide":16,"./_redefine":28}],13:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],14:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],15:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],16:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":9,"./_object-dp":22,"./_property-desc":27}],17:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":9,"./_dom-create":10,"./_fails":13}],18:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":5}],19:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],20:[function(require,module,exports){
module.exports = false;

},{}],21:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":13,"./_iobject":18,"./_object-gops":23,"./_object-keys":25,"./_object-pie":26,"./_to-object":35}],22:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":3,"./_descriptors":9,"./_ie8-dom-define":17,"./_to-primitive":36}],23:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],24:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":4,"./_has":15,"./_shared-key":29,"./_to-iobject":33}],25:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":11,"./_object-keys-internal":24}],26:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],27:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],28:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":6,"./_global":14,"./_has":15,"./_hide":16,"./_uid":37}],29:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":30,"./_uid":37}],30:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":6,"./_global":14,"./_library":20}],31:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":32}],32:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],33:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":8,"./_iobject":18}],34:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":32}],35:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":8}],36:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":19}],37:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],38:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":12,"./_object-assign":21}],39:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self).VueClamp=t()}(this,function(){"use strict";var e=null;var t=null;function i(e,t){void 0===t&&(t={});var i=document.createElement(e);return Object.keys(t).forEach(function(e){i[e]=t[e]}),i}function r(e,t,i){return(window.getComputedStyle(e,i||null)||{display:"none"})[t]}function s(e){if(!document.documentElement.contains(e))return{detached:!0,rendered:!1};for(var t=e;t!==document;){if("none"===r(t,"display"))return{detached:!1,rendered:!1};t=t.parentNode}return{detached:!1,rendered:!0}}var n='.resize-triggers{visibility:hidden;opacity:0}.resize-contract-trigger,.resize-contract-trigger:before,.resize-expand-trigger,.resize-triggers{content:"";position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden}.resize-contract-trigger,.resize-expand-trigger{background:#eee;overflow:auto}.resize-contract-trigger:before{width:200%;height:200%}',o=0,a=null;function l(e,t){if(e.__resize_mutation_handler__||(e.__resize_mutation_handler__=function(){var e=s(this),t=e.rendered,i=e.detached;t!==this.__resize_rendered__&&(!i&&this.__resize_triggers__&&(h(this),this.addEventListener("scroll",_,!0)),this.__resize_rendered__=t,d(this))}.bind(e)),!e.__resize_listeners__)if(e.__resize_listeners__=[],window.ResizeObserver){var l=e.offsetWidth,c=e.offsetHeight,f=new ResizeObserver(function(){(e.__resize_observer_triggered__||(e.__resize_observer_triggered__=!0,e.offsetWidth!==l||e.offsetHeight!==c))&&d(e)}),u=s(e),p=u.detached,g=u.rendered;e.__resize_observer_triggered__=!1===p&&!1===g,e.__resize_observer__=f,f.observe(e)}else if(e.attachEvent&&e.addEventListener)e.__resize_legacy_resize_handler__=function(){d(e)},e.attachEvent("onresize",e.__resize_legacy_resize_handler__),document.addEventListener("DOMSubtreeModified",e.__resize_mutation_handler__);else if(o||(a=function(e){var t=document.createElement("style");return t.type="text/css",t.styleSheet?t.styleSheet.cssText=e:t.appendChild(document.createTextNode(e)),(document.querySelector("head")||document.body).appendChild(t),t}(n)),function(e){var t=r(e,"position");t&&"static"!==t||(e.style.position="relative");e.__resize_old_position__=t,e.__resize_last__={};var s=i("div",{className:"resize-triggers"}),n=i("div",{className:"resize-expand-trigger"}),o=i("div"),a=i("div",{className:"resize-contract-trigger"});n.appendChild(o),s.appendChild(n),s.appendChild(a),e.appendChild(s),e.__resize_triggers__={triggers:s,expand:n,expandChild:o,contract:a},h(e),e.addEventListener("scroll",_,!0),e.__resize_last__={width:e.offsetWidth,height:e.offsetHeight}}(e),e.__resize_rendered__=s(e).rendered,window.MutationObserver){var m=new MutationObserver(e.__resize_mutation_handler__);m.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0}),e.__resize_mutation_observer__=m}e.__resize_listeners__.push(t),o++}function _(){var i,r,s=this;h(this),this.__resize_raf__&&(i=this.__resize_raf__,t||(t=(window.cancelAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame||function(e){clearTimeout(e)}).bind(window)),t(i)),this.__resize_raf__=(r=function(){var e,t,i,r,n,o,a=(t=(e=s).__resize_last__,i=t.width,r=t.height,n=e.offsetWidth,o=e.offsetHeight,n!==i||o!==r?{width:n,height:o}:null);a&&(s.__resize_last__=a,d(s))},e||(e=(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(e){return setTimeout(e,16)}).bind(window)),e(r))}function d(e){e.__resize_listeners__.forEach(function(t){t.call(e)})}function h(e){var t=e.__resize_triggers__,i=t.expand,r=t.expandChild,s=t.contract,n=s.scrollWidth,o=s.scrollHeight,a=i.offsetWidth,l=i.offsetHeight,_=i.scrollWidth,d=i.scrollHeight;s.scrollLeft=n,s.scrollTop=o,r.style.width=a+1+"px",r.style.height=l+1+"px",i.scrollLeft=_,i.scrollTop=d}var c=["maxLines","maxHeight","ellipsis","isClamped"],f=["tag","text","autoresize"];return{name:"vue-clamper",props:{tag:{type:String,default:"div"},autoresize:{type:Boolean,default:!1},maxLines:Number,maxHeight:[String,Number],ellipsis:{type:String,default:"…"},expanded:Boolean},data:function(){return{offset:null,text:this.getText(),localExpanded:!!this.expanded}},computed:{clampedText:function(){return this.text.slice(0,this.offset)+this.ellipsis},isClamped:function(){return!!this.text&&this.offset!==this.text.length},realText:function(){return this.isClamped?this.clampedText:this.text},realMaxHeight:function(){if(this.localExpanded)return null;var e=this.maxHeight;return e?"number"==typeof e?e+"px":e:null}},watch:{expanded:function(e){this.localExpanded=e},localExpanded:function(e){e?this.clampAt(this.text.length):this.update(),this.expanded!==e&&this.$emit("update:expanded",e)}},mounted:function(){var e=this;this.init(),f.forEach(function(t){e.$watch(t,e.init)}),c.forEach(function(t){e.$watch(t,e.update)})},updated:function(){this.text=this.getText(),this.applyChange()},beforeDestroy:function(){this.cleanUp()},methods:{init:function(){var e=this;if(this.$slots.default){if(this.offset=this.text.length,this.cleanUp(),this.autoresize){var t=function(){e.update()};l(this.$el,t),this.unregisterResizeCallback=function(){!function(e,t){if(e.detachEvent&&e.removeEventListener)return e.detachEvent("onresize",e.__resize_legacy_resize_handler__),void document.removeEventListener("DOMSubtreeModified",e.__resize_mutation_handler__);var i=e.__resize_listeners__;i&&(i.splice(i.indexOf(t),1),i.length||(e.__resize_observer__?(e.__resize_observer__.unobserve(e),e.__resize_observer__.disconnect(),e.__resize_observer__=null):(e.__resize_mutation_observer__&&(e.__resize_mutation_observer__.disconnect(),e.__resize_mutation_observer__=null),e.removeEventListener("scroll",_),e.removeChild(e.__resize_triggers__.triggers),e.__resize_triggers__=null),e.__resize_listeners__=null),!--o&&a&&a.parentNode.removeChild(a))}(e.$el,t)}}this.update()}},update:function(){this.localExpanded||(this.applyChange(),(this.isOverflow()||this.isClamped)&&this.search())},expand:function(){this.localExpanded=!0},collapse:function(){this.localExpanded=!1},toggle:function(){this.localExpanded=!this.localExpanded},isOverflow:function(){if(!this.maxLines&&!this.maxHeight)return!1;if(this.maxLines&&this.$refs.content.getClientRects().length>this.maxLines)return!0;return!!(this.maxHeight&&this.$el.scrollHeight>this.$el.offsetHeight)},getText:function(){var e=(this.$slots.default||[]).filter(function(e){return!e.tag&&!e.isComment})[0];return e?e.text:""},moveEdge:function(e){this.clampAt(this.offset+e)},clampAt:function(e){this.offset=e,this.applyChange()},applyChange:function(){this.$refs.text.textContent=this.realText},stepToFit:function(){this.fill(),this.clamp()},fill:function(){for(;!this.isOverflow()&&this.offset<this.text.length;)this.moveEdge(1)},clamp:function(){for(;this.isOverflow()&&this.offset>0;)this.moveEdge(-1)},search:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var i=e[0];void 0===i&&(i=0);var r=e[1];if(void 0===r&&(r=this.offset),r-i<=3)this.stepToFit();else{var s=Math.floor((r+i)/2);this.clampAt(s),this.isOverflow()?this.search(i,s):this.search(s,r)}},cleanUp:function(){this.unregisterResizeCallback&&this.unregisterResizeCallback()}},render:function(e){var t=[e("span",{ref:"text",attrs:{"aria-label":this.text.trim()}},this.realText)],i={expand:this.expand,collapse:this.collapse,toggle:this.toggle,clamped:this.isClamped,expanded:this.localExpanded},r=this.$scopedSlots.before?this.$scopedSlots.before(i):this.$slots.before;r&&t.unshift.apply(t,Array.isArray(r)?r:[r]);var s=this.$scopedSlots.after?this.$scopedSlots.after(i):this.$slots.after;s&&t.push.apply(t,Array.isArray(s)?s:[s]);var n=[e("span",{style:{boxShadow:"transparent 0 0"},ref:"content"},t)];return e(this.tag,{style:{maxHeight:this.realMaxHeight,overflow:"hidden"}},n)}}});

},{}],40:[function(require,module,exports){
function validate(binding) {
  if (typeof binding.value !== 'function') {
    console.warn('[Vue-click-outside:] provided expression', binding.expression, 'is not a function.')
    return false
  }

  return true
}

function isPopup(popupItem, elements) {
  if (!popupItem || !elements)
    return false

  for (var i = 0, len = elements.length; i < len; i++) {
    try {
      if (popupItem.contains(elements[i])) {
        return true
      }
      if (elements[i].contains(popupItem)) {
        return false
      }
    } catch(e) {
      return false
    }
  }

  return false
}

function isServer(vNode) {
  return typeof vNode.componentInstance !== 'undefined' && vNode.componentInstance.$isServer
}

exports = module.exports = {
  bind: function (el, binding, vNode) {
    if (!validate(binding)) return

    // Define Handler and cache it on the element
    function handler(e) {
      if (!vNode.context) return

      // some components may have related popup item, on which we shall prevent the click outside event handler.
      var elements = e.path || (e.composedPath && e.composedPath())
      elements && elements.length > 0 && elements.unshift(e.target)
      
      if (el.contains(e.target) || isPopup(vNode.context.popupItem, elements)) return

      el.__vueClickOutside__.callback(e)
    }

    // add Event Listeners
    el.__vueClickOutside__ = {
      handler: handler,
      callback: binding.value
    }
    !isServer(vNode) && document.addEventListener('click', handler)
  },

  update: function (el, binding) {
    if (validate(binding)) el.__vueClickOutside__.callback = binding.value
  },
  
  unbind: function (el, binding, vNode) {
    // Remove Event Listeners
    !isServer(vNode) && document.removeEventListener('click', el.__vueClickOutside__.handler)
    delete el.__vueClickOutside__
  }
}

},{}],41:[function(require,module,exports){
var inserted = exports.cache = {}

function noop () {}

exports.insert = function (css) {
  if (inserted[css]) return noop
  inserted[css] = true

  var elem = document.createElement('style')
  elem.setAttribute('type', 'text/css')

  if ('textContent' in elem) {
    elem.textContent = css
  } else {
    elem.styleSheet.cssText = css
  }

  document.getElementsByTagName('head')[0].appendChild(elem)
  return function () {
    document.getElementsByTagName('head')[0].removeChild(elem)
    inserted[css] = false
  }
}

},{}],42:[function(require,module,exports){
module.exports={
  "top-menu": "Top menu",
  "show-submenu": "Show submenu",
  "hide-submenu": "Hide submenu",
  "links": "Links"
}

},{}],43:[function(require,module,exports){
module.exports={
  "top-menu": "Toppmeny",
  "show-submenu": "Visa undermeny",
  "hide-submenu": "Göm undermeny",
  "links": "Länkar"
}

},{}],44:[function(require,module,exports){
;(function(){
"use strict";

var _TopItem = _interopRequireDefault(require("./components/TopItem.vue"));

var _store = _interopRequireDefault(require("./store"));

var _i18n = _interopRequireDefault(require("./i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = {
  name: 'MegaMenu',
  store: _store["default"],
  i18n: _i18n["default"],
  computed: {
    items: function items() {
      return this.$store.state.items;
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.commit('config', this.$options.config);
    this.$store.commit('items', this.$options.items);
    this.$store.dispatch('getCurrentPage');
  },
  components: {
    TopItem: _TopItem["default"]
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{ref:"menu",staticClass:"foi-mega-menu",attrs:{"aria-label":_vm.$t('top-menu')}},[_c('ul',_vm._l((_vm.items),function(item){return _c('top-item',{key:item.id,attrs:{"item":item}})}),1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5737fa4e", __vue__options__)
  } else {
    hotAPI.reload("data-v-5737fa4e", __vue__options__)
  }
})()}
},{"./components/TopItem.vue":54,"./i18n":55,"./store":57,"vue":"vue","vue-hot-reload-api":undefined}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = focusLastAnchor;

function focusLastAnchor($el) {
  if ($el) {
    var anchors = $el.querySelectorAll('a');

    if (anchors.length) {
      anchors[anchors.length - 1].focus();
    }
  }
}

},{}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = focusNextAnchor;

function focusNextAnchor($el) {
  if ($el && $el.querySelector('a')) {
    $el.querySelector('a').focus();
  }
}

},{}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCurrentPage;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getCurrentPage(_ref) {
  var url = _ref.url;
  return (0, _axios["default"])({
    method: 'get',
    url: url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
}

},{"axios":"axios"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setHeaderExpanded;

function setHeaderExpanded(expanded) {
  var header = document.querySelector('header.foi-header-wrapper');
  var cover = document.querySelector('.foi-cover');

  if (header) {
    if (expanded) {
      header.classList.add('foi-megamenu--expanded');
      cover.classList.add('foi-cover--visible');
    } else {
      header.classList.remove('foi-megamenu--expanded');
      cover.classList.remove('foi-cover--visible');
    }
  }
}

},{}],49:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 27, stdin */\n.foi-mega-menu-blurb-list[data-v-3e5be078] {\n  margin-top: 10px; }\n\n/* line 31, stdin */\n.foi-mega-menu-blurb[data-v-3e5be078] {\n  width: 100%;\n  min-height: 150px;\n  max-height: 220px;\n  margin: 0 0 10px 0; }\n  /* line 37, stdin */\n  .foi-mega-menu-blurb__image[data-v-3e5be078] {\n    min-height: 150px;\n    width: 100%;\n    background-repeat: no-repeat;\n    background-size: cover; }\n  /* line 44, stdin */\n  .foi-mega-menu-blurb__content[data-v-3e5be078] {\n    background-color: #333366;\n    padding: 10px 15px;\n    width: 100%; }\n  /* line 50, stdin */\n  .foi-mega-menu-blurb__desc[data-v-3e5be078] {\n    text-decoration: none;\n    font-family: FFMetaPro;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 1.19;\n    color: white; }")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clickableElement = _interopRequireDefault(require("../../../../client/vue/directives/clickable-element"));

var _vueClamp = _interopRequireDefault(require("vue-clamp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: 'Blurb',
  props: ['items'],
  methods: {
    focusNext: function focusNext() {
      this.$emit('focus-next');
    },
    focusPrevious: function focusPrevious() {
      this.$emit('focus-previous');
    },
    getBackgroundImage: function getBackgroundImage(uri) {
      return {
        backgroundImage: "url(\"".concat(uri, "\")")
      };
    }
  },
  directives: {
    clickableElement: _clickableElement["default"]
  },
  components: {
    VClamp: _vueClamp["default"]
  }
};
exports["default"] = _default;
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('ul',{staticClass:"foi-mega-menu-blurb-list"},_vm._l((_vm.items),function(item){return _c('li',{directives:[{name:"clickable-element",rawName:"v-clickable-element"}],key:item.uri,staticClass:"foi-mega-menu-blurb",on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.focusNext($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.focusNext($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.focusPrevious($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.focusPrevious($event)}]}},[_c('div',{staticClass:"foi-mega-menu-blurb__image",style:(_vm.getBackgroundImage(item.image.uri))},[_c('span',{attrs:{"role":"img","aria-label":item.image.alt}})]),_vm._v(" "),(item.desc)?_c('div',{staticClass:"foi-mega-menu-blurb__content"},[_c('a',{staticClass:"foi-mega-menu-blurb__desc",attrs:{"href":item.uri}},[_c('v-clamp',{attrs:{"autoresize":"","max-lines":2}},[_vm._v(_vm._s(item.desc))])],1)]):_c('a',{attrs:{"href":item.uri}})])}),0):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-3e5be078"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e5be078", __vue__options__)
  } else {
    hotAPI.reload("data-v-3e5be078", __vue__options__)
  }
})()}
},{"../../../../client/vue/directives/clickable-element":58,"vue":"vue","vue-clamp":39,"vue-hot-reload-api":undefined,"vueify/lib/insert-css":41}],50:[function(require,module,exports){
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SubItem = _interopRequireDefault(require("./SubItem.vue"));

var _focusNextAnchor = _interopRequireDefault(require("../api/focusNextAnchor"));

var _focusLastAnchor = _interopRequireDefault(require("../api/focusLastAnchor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: 'ItemList',
  props: ['items', 'item-class', 'is-top'],
  methods: {
    focusPreviousItem: function focusPreviousItem(i) {
      var prev = i - 1;

      if (this.$refs.items[prev]) {
        (0, _focusLastAnchor["default"])(this.$refs.items[prev].$el);
      } else {
        this.$emit('focus-previous');
      }
    },
    focusNextItem: function focusNextItem(i) {
      var next = i + 1;

      if (this.$refs.items[next]) {
        (0, _focusNextAnchor["default"])(this.$refs.items[next].$el);
      } else {
        this.$emit('focus-next');
      }
    },
    focusPreviousParent: function focusPreviousParent(i) {
      if (this.isTop) {
        this.focusPreviousItem(i);
      } else {
        this.$emit('focus-previous-parent');
      }
    },
    focusNextParent: function focusNextParent(i) {
      if (this.isTop) {
        this.focusNextItem(i);
      } else {
        this.$emit('focus-next-parent');
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.$options.components.SubItem = _SubItem["default"];
  }
};
exports["default"] = _default;
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item,index){return _c('sub-item',{key:item.id,ref:"items",refInFor:true,class:_vm.itemClass,attrs:{"item":item},on:{"focus-previous":function($event){return _vm.focusPreviousItem(index)},"focus-next":function($event){return _vm.focusNextItem(index)},"focus-previous-parent":function($event){return _vm.focusPreviousParent(index)},"focus-next-parent":function($event){return _vm.focusNextParent(index)}}})}),1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-91570078", __vue__options__)
  } else {
    hotAPI.reload("data-v-91570078", __vue__options__)
  }
})()}
},{"../api/focusLastAnchor":45,"../api/focusNextAnchor":46,"./SubItem.vue":53,"vue":"vue","vue-hot-reload-api":undefined}],51:[function(require,module,exports){
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'KeywordList',
  props: ['keywords'],
  data: function data() {
    return {};
  }
};
exports["default"] = _default;
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foi-mega-menu-keywords"},_vm._l((_vm.keywords),function(keyword){return _c('span',{key:keyword,staticClass:"badge"},[_vm._v(_vm._s(keyword))])}),0)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28ce27f8", __vue__options__)
  } else {
    hotAPI.reload("data-v-28ce27f8", __vue__options__)
  }
})()}
},{"vue":"vue","vue-hot-reload-api":undefined}],52:[function(require,module,exports){
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'LinkList',
  props: ['title', 'links', 'listClass'],
  data: function data() {
    return {};
  },
  methods: {
    focusPreviousParent: function focusPreviousParent() {
      this.$emit('focus-previous');
    },
    focusNextParent: function focusNextParent() {
      this.$emit('focus-next');
    },
    focusPrevious: function focusPrevious(index) {
      var prev = index - 1;

      if (this.$refs.link[prev]) {
        this.$refs.link[prev].focus();
      } else {
        this.$emit('focus-previous');
      }
    },
    focusNext: function focusNext(index) {
      var next = index + 1;

      if (this.$refs.link[next]) {
        this.$refs.link[next].focus();
      } else {
        this.$emit('focus-next');
      }
    }
  }
};
exports["default"] = _default;
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foi-mega-menu-link-list",class:_vm.listClass},[(_vm.title)?_c('div',{staticClass:"foi-mega-menu-link-list__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.links),function(link,index){return _c('li',{key:link.uri},[_c('a',{ref:"link",refInFor:true,attrs:{"href":link.uri},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.focusPrevious(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.focusNext(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.focusPreviousParent($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.focusNextParent($event)}]}},[_vm._v(_vm._s(link.name))])])}),0)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52bc44aa", __vue__options__)
  } else {
    hotAPI.reload("data-v-52bc44aa", __vue__options__)
  }
})()}
},{"vue":"vue","vue-hot-reload-api":undefined}],53:[function(require,module,exports){
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ItemList = _interopRequireDefault(require("./ItemList.vue"));

var _KeywordList = _interopRequireDefault(require("./KeywordList.vue"));

var _focusNextAnchor = _interopRequireDefault(require("../api/focusNextAnchor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: 'SubItem',
  props: ['item'],
  computed: {
    hasChildren: function hasChildren() {
      return this.item.children && this.item.children.length > 0;
    },
    hasKeywords: function hasKeywords() {
      return this.item.keywords && this.item.keywords.length > 0;
    },
    isCurrent: function isCurrent() {
      return this.$store.state.currentPageId === this.item.id;
    }
  },
  methods: {
    focusThisItem: function focusThisItem() {
      if (this.item.isFolder) {
        this.focusPreviousParent();
      } else {
        (0, _focusNextAnchor["default"])(this.$refs.li);
      }
    },
    focusPreviousSibling: function focusPreviousSibling() {
      this.$emit('focus-previous');
    },
    focusNextSibling: function focusNextSibling() {
      this.$emit('focus-next');
    },
    focusPreviousParent: function focusPreviousParent() {
      this.$emit('focus-previous-parent');
    },
    focusNextParent: function focusNextParent() {
      this.$emit('focus-next-parent');
    },
    focusFirstChild: function focusFirstChild() {
      if (this.$refs.children) {
        (0, _focusNextAnchor["default"])(this.$refs.children.$el);
      } else {
        this.focusNextSibling();
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.$options.components.ItemList = _ItemList["default"];
    this.$options.components.KeywordList = _KeywordList["default"];
  }
};
exports["default"] = _default;
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"li",attrs:{"aria-level":_vm.item.level}},[(_vm.item.isFolder)?_c('div',{staticClass:"foi-mega-menu-sub-item foi-mega-menu-sub-item--folder",class:{'foi-mega-menu-sub-item--current' : _vm.isCurrent },attrs:{"data-level":_vm.item.level,"aria-current":_vm.isCurrent ? 'page' : false}},[_c('span',{staticClass:"foi-mega-menu-sub-item__name"},[_vm._v("\n        "+_vm._s(_vm.item.displayName)+"\n      ")])]):_c('a',{staticClass:"foi-mega-menu-sub-item",class:{'foi-mega-menu-sub-item--current' : _vm.isCurrent },attrs:{"href":_vm.item.uri,"data-level":_vm.item.level,"aria-current":_vm.isCurrent ? 'page' : false},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.focusPreviousSibling($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.focusFirstChild($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.focusPreviousParent($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.focusNextParent($event)}]}},[_c('span',{staticClass:"foi-mega-menu-sub-item__name"},[_vm._v("\n        "+_vm._s(_vm.item.displayName)+"\n      ")])]),_vm._v(" "),(_vm.hasChildren)?_c('item-list',{ref:"children",attrs:{"items":_vm.item.children},on:{"focus-previous":_vm.focusThisItem,"focus-next":_vm.focusNextSibling,"focus-previous-parent":_vm.focusPreviousSibling,"focus-next-parent":_vm.focusNextSibling}}):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01f1f7d0", __vue__options__)
  } else {
    hotAPI.reload("data-v-01f1f7d0", __vue__options__)
  }
})()}
},{"../api/focusNextAnchor":46,"./ItemList.vue":50,"./KeywordList.vue":51,"vue":"vue","vue-hot-reload-api":undefined}],54:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".mega-fade-enter-active,\n.mega-fade-leave-active {\n  transition: opacity 250ms;\n}\n.mega-fade-enter,\n.mega-fade-leave-to {\n  opacity: 0;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vueClickOutside = _interopRequireDefault(require("vue-click-outside"));

var _ItemList = _interopRequireDefault(require("./ItemList.vue"));

var _LinkList = _interopRequireDefault(require("./LinkList.vue"));

var _Blurb = _interopRequireDefault(require("./Blurb.vue"));

var _focusNextAnchor = _interopRequireDefault(require("../api/focusNextAnchor"));

var _focusLastAnchor = _interopRequireDefault(require("../api/focusLastAnchor"));

var _setHeaderExpanded = _interopRequireDefault(require("../api/setHeaderExpanded"));

var _i18n = _interopRequireDefault(require("../i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var hoverTimeout;

function preventKeyScroll(e) {
  if ([32, 35, 36, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
    e.preventDefault();
  }
}

function addPreventKeyScroll() {
  window.addEventListener('keydown', preventKeyScroll, false);
}

function removePreventKeyScroll() {
  window.removeEventListener('keydown', preventKeyScroll, false);
}

var _default = {
  name: 'TopItem',
  props: ['item'],
  computed: {
    elementId: function elementId() {
      return "top_item_".concat(this.item.id.replace('.', '_'));
    },
    topParent: function topParent() {
      return this.$refs.itemList.$el;
    },
    isExpanded: function isExpanded() {
      return this.$store.state.currentExpandedId === this.item.id;
    },
    hasChildren: function hasChildren() {
      return this.item.children && this.item.children.length > 0;
    },
    inactiveMenu: function inactiveMenu() {
      return this.item.inactiveMenu;
    },
    hasThemes: function hasThemes() {
      return this.item.themes.length > 0;
    },
    hasLinks: function hasLinks() {
      return this.item.links.length > 0;
    },
    isCurrent: function isCurrent() {
      return this.$store.state.currentPageId === this.item.id;
    },
    isActive: function isActive() {
      return this.$store.state.currentActiveId === this.item.id;
    },
    ariaExpanded: function ariaExpanded() {
      if (!this.hasChildren) {
        return false;
      }

      return this.isExpanded ? 'true' : 'false';
    },
    ariaHidden: function ariaHidden() {
      return !this.isExpanded ? 'true' : 'false';
    },
    linksTitle: function linksTitle() {
      return this.item.linksTitle || this.$t('links');
    }
  },
  methods: {
    clearExpanded: function clearExpanded() {
      this.$nextTick(function () {
        removePreventKeyScroll();
      });
      this.$store.commit('currentExpandedId', '');
      (0, _setHeaderExpanded["default"])(false);
    },
    setExpanded: function setExpanded() {
      addPreventKeyScroll();
      this.$store.commit('currentExpandedId', this.item.id);
      (0, _setHeaderExpanded["default"])(true);
    },
    showItemList: function showItemList(e) {
      var _this = this;

      if (e instanceof MouseEvent) {
        hoverTimeout = setTimeout(function () {
          _this.setExpanded();
        }, 500);
      } else {
        this.setExpanded();
        this.$nextTick(function () {
          (0, _focusNextAnchor["default"])(_this.$refs.content);
        });
      }
    },
    hideItemList: function hideItemList() {
      clearTimeout(hoverTimeout);

      if (this.isExpanded) {
        this.clearExpanded();
        this.focusCurrentTopItem();
      }
    },
    toggleItemList: function toggleItemList(e) {
      if (!this.isExpanded) {
        e.preventDefault();
        this.setExpanded();
      }
    },
    focusCurrentTopItem: function focusCurrentTopItem() {
      (0, _focusNextAnchor["default"])(this.$refs.li);
    },
    focusPreviousTopItem: function focusPreviousTopItem() {
      if (this.$refs.li.previousElementSibling) {
        (0, _focusNextAnchor["default"])(this.$refs.li.previousElementSibling);
      }
    },
    focusNextTopItem: function focusNextTopItem() {
      if (this.$refs.li.nextElementSibling) {
        (0, _focusNextAnchor["default"])(this.$refs.li.nextElementSibling);
      } else {
        this.focusCurrentTopItem();
      }
    },
    focusFirstChild: function focusFirstChild() {
      if (this.$refs.children) {
        (0, _focusNextAnchor["default"])(this.$refs.children.$el);
      }
    },
    focusLastChild: function focusLastChild() {
      if (this.$refs.children) {
        (0, _focusLastAnchor["default"])(this.$refs.children.$el);
      }
    },
    focusBlurb: function focusBlurb() {
      if (this.$refs.blurb) {
        (0, _focusNextAnchor["default"])(this.$refs.blurb.$el);
      }
    },
    focusTopItemLink: function focusTopItemLink() {
      if (this.$refs.topItemLink) {
        (0, _focusNextAnchor["default"])(this.$refs.content);
      }
    },
    focusThemes: function focusThemes() {
      if (this.$refs.themes) {
        (0, _focusNextAnchor["default"])(this.$refs.themes.$el);
      } else {
        this.focusLinks();
      }
    },
    focusLastTheme: function focusLastTheme() {
      if (this.$refs.themes) {
        (0, _focusLastAnchor["default"])(this.$refs.themes.$el);
      } else {
        this.focusLastChild();
      }
    },
    focusLinks: function focusLinks() {
      if (this.item.links.length > 0) {
        (0, _focusNextAnchor["default"])(this.$refs.links.$el);
      } else {
        this.focusNextTopItem();
      }
    }
  },
  components: {
    ItemList: _ItemList["default"],
    LinkList: _LinkList["default"],
    Blurb: _Blurb["default"]
  },
  directives: {
    ClickOutside: _vueClickOutside["default"]
  }
};
exports["default"] = _default;
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideItemList),expression:"hideItemList"}],ref:"li",attrs:{"aria-level":_vm.item.level},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.hideItemList($event)}}},[(_vm.hasChildren && !_vm.inactiveMenu)?_c('a',{staticClass:"foi-mega-menu-item",class:{
      'foi-mega-menu-item--active': _vm.isActive || _vm.isCurrent,
      'foi-mega-menu-item--expanded': _vm.isExpanded
    },attrs:{"href":_vm.item.uri,"aria-expanded":_vm.ariaExpanded,"aria-current":_vm.isCurrent ? 'page' : false,"aria-controls":_vm.elementId,"data-level":_vm.item.level,"data-isAncestor":_vm.item.isAncestor,"role":"button"},on:{"focusin":_vm.clearExpanded,"click":_vm.toggleItemList,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.toggleItemList($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.showItemList($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.hideItemList($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.focusPreviousTopItem($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.focusNextTopItem($event)}]}},[_c('span',{staticClass:"foi-mega-menu-item__name"},[_vm._v("\n      "+_vm._s(_vm.item.displayName)+"\n    ")])]):_c('a',{staticClass:"foi-mega-menu-item",class:{
      'foi-mega-menu-item--active': _vm.isActive || _vm.isCurrent,
      'foi-mega-menu-item--expanded': _vm.isExpanded
    },attrs:{"href":_vm.item.uri,"aria-expanded":_vm.ariaExpanded,"aria-current":_vm.isCurrent ? 'page' : false,"aria-controls":_vm.elementId,"data-level":_vm.item.level,"data-isAncestor":_vm.item.isAncestor},on:{"focusin":_vm.clearExpanded,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.focusPreviousTopItem($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.focusNextTopItem($event)}]}},[_c('span',{staticClass:"foi-mega-menu-item__name"},[_vm._v("\n      "+_vm._s(_vm.item.displayName)+"\n    ")])]),_vm._v(" "),_c('div',{ref:"content",staticClass:"container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExpanded),expression:"isExpanded"}],staticClass:"foi-mega-menu-hover-helper"}),_vm._v(" "),_c('transition',{attrs:{"name":"mega-fade"}},[(_vm.hasChildren)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExpanded),expression:"isExpanded"}],staticClass:"foi-mega-menu-items",attrs:{"id":_vm.elementId,"role":"region","aria-hidden":_vm.ariaHidden}},[_c('div',{staticClass:"foi-mega-menu-items__header row"},[_c('div',{staticClass:"col-lg-8"}),_vm._v(" "),(_vm.item.hasThemes)?_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('div',{staticClass:"foi-mega-menu-items__themes-title"},[_vm._v("Teman")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"foi-mega-menu-items__close btn btn-link",on:{"click":_vm.hideItemList}},[_c('i',{staticClass:"far fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"foi-mega-menu-items__content row"},[_c('div',{staticClass:"foi-mega-menu-items__column",class:{ 'col-lg-8': _vm.item.hasThemes, 'col-lg-9': !_vm.item.hasThemes }},[_c('item-list',{ref:"children",staticClass:"foi-mega-menu-items__list",class:{ 'foi-mega-menu-items__list--narrow': _vm.item.hasThemes },attrs:{"items":_vm.item.children,"item-class":"foi-mega-menu-items__item","is-top":"true"},on:{"focus-next":_vm.focusThemes,"focus-previous":_vm.focusTopItemLink}})],1),_vm._v(" "),(_vm.item.hasThemes)?_c('div',{staticClass:"col-lg-2"},[_c('div',{staticClass:"foi-mega-menu-items__themes-title d-lg-none"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('link-list',{ref:"themes",attrs:{"listClass":"foi-mega-menu-items__themes","links":_vm.item.themes},on:{"focus-next":_vm.focusLinks,"focus-previous":_vm.focusLastChild}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('link-list',{ref:"links",attrs:{"title":_vm.linksTitle,"listClass":"foi-mega-menu-items__links","links":_vm.item.links},on:{"focus-next":_vm.focusNextTopItem,"focus-previous":_vm.focusLastTheme}}),_vm._v(" "),_c('blurb',{attrs:{"items":_vm.item.blurbs}})],1)])]):_vm._e()])],1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e47d436", __vue__options__)
  } else {
    hotAPI.reload("data-v-0e47d436", __vue__options__)
  }
})()}
},{"../api/focusLastAnchor":45,"../api/focusNextAnchor":46,"../api/setHeaderExpanded":48,"../i18n":55,"./Blurb.vue":49,"./ItemList.vue":50,"./LinkList.vue":52,"vue":"vue","vue-click-outside":40,"vue-hot-reload-api":undefined,"vueify/lib/insert-css":41}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vueI18n = _interopRequireDefault(require("vue-i18n"));

var _sv = _interopRequireDefault(require("../src/i18n/sv.json"));

var _en = _interopRequireDefault(require("../src/i18n/en.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = new _vueI18n["default"]({
  locale: document.documentElement.lang,
  messages: {
    sv: _sv["default"],
    en: _en["default"]
  }
});

exports["default"] = _default;

},{"../src/i18n/en.json":42,"../src/i18n/sv.json":43,"vue-i18n":"vue-i18n"}],56:[function(require,module,exports){
"use strict";

var _App = _interopRequireDefault(require("./App.vue"));

var _render = _interopRequireDefault(require("../../../client/vue/render"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.vueApps[_App["default"].name] = {
  App: _App["default"],
  render: _render["default"]
};

},{"../../../client/vue/render":59,"./App.vue":44}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vuex = _interopRequireDefault(require("vuex"));

var _getCurrentPage2 = _interopRequireDefault(require("./api/getCurrentPage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getActiveId(items, currentId) {
  if (items) {
    return items.filter(function (item) {
      return item.id === currentId || getActiveId(item.children, currentId);
    }).map(function (item) {
      return item.id;
    })[0] || '';
  }

  return '';
}

var _default = new _vuex["default"].Store({
  state: {
    config: {},
    currentPageId: '',
    currentExpandedId: '',
    currentActiveId: '',
    items: []
  },
  mutations: {
    config: function config(state, _config) {
      state.config = _config;
    },
    currentPageId: function currentPageId(state, pageId) {
      state.currentPageId = pageId;
    },
    currentExpandedId: function currentExpandedId(state, pageId) {
      state.currentExpandedId = pageId;
    },
    currentActiveId: function currentActiveId(state, pageId) {
      state.currentActiveId = pageId;
    },
    items: function items(state, _items) {
      state.items = _items;
    }
  },
  actions: {
    getCurrentPage: function getCurrentPage(_ref) {
      var state = _ref.state,
          commit = _ref.commit;
      return (0, _getCurrentPage2["default"])({
        url: state.config.getCurrentIdUrl
      }).then(function (response) {
        commit('currentPageId', response.data.id);
        commit('currentActiveId', getActiveId(state.items, response.data.id));
      });
    }
  }
});

exports["default"] = _default;

},{"./api/getCurrentPage":47,"vuex":"vuex"}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint no-param-reassign: ["error", { "props": false }] */
var _default = function clickableElement() {
  function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b".concat(className, "\\b")).test(el.className);
  }

  function addClass(el, className) {
    if (el.classList) el.classList.add(className);else if (!hasClass(el, className)) el.className += " ".concat(className);
  }

  function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp("\\b".concat(className, "\\b"), 'g'), '');
  }

  return {
    inserted: function inserted(el) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var url = el.querySelector('a').href;

        if (e.ctrlKey) {
          window.open(url, '_blank');
        } else {
          window.open(url, '_self');
        }
      });
      el.addEventListener('focusin', function () {
        addClass(el, 'foi-focus-outline-show');
      });
      el.addEventListener('focusout', function () {
        removeClass(el, 'foi-focus-outline-show');
      });
    }
  };
}();

exports["default"] = _default;

},{}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = render;

require("core-js/fn/object/assign");

var _vue = _interopRequireDefault(require("vue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.vueApps = window.vueApps || {};

function render(name, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object.assign(window.vueApps[name].App, options);
  new _vue["default"](window.vueApps[name].App).$mount("[data-vue-portlet=\"".concat(id, "\"]"));
}

},{"core-js/fn/object/assign":1,"vue":"vue"}]},{},[56]);
